var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import * as StateClasses from '../classes/index';
import * as serviceEventSliceActions from '../store/slices/serviceEventSlice';
import * as appSliceActions from '../store/slices/AppSlice';
import styles from './css/location.module.css';
var Location = /** @class */ (function (_super) {
    __extends(Location, _super);
    function Location(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (e) {
            var _a;
            _this.setState({ location: __assign(__assign({}, _this.state.location), (_a = {}, _a[e.target.name] = e.target.value, _a)) });
        };
        _this.componentDidMount = function () {
            _this.props.dispatch(appSliceActions.setTimeLineStep(2));
            // merge in state
            var mergedLocation = Object.assign(_this.state.location, _this.props.locationState);
            _this.setState({ location: mergedLocation });
            console.log('location mount');
        };
        _this.onSubmit = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                e.preventDefault();
                // Service Event requires phone number to save contact.. so at this point we just save to state
                // save to global state
                this.props.dispatch(serviceEventSliceActions.saveLocation(__assign({}, this.state.location)));
                this.props.history.push('/activation/mount');
                return [2 /*return*/];
            });
        }); };
        // copy global state location
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.state = {
            location: new StateClasses.Location()
        };
        return _this;
    }
    Location.prototype.render = function () {
        return (React.createElement("div", { className: "contentHolder" },
            React.createElement("h2", null, "Help us with some additional information so we can prepare for your home visit:"),
            React.createElement("div", { className: styles.content },
                React.createElement("form", { onSubmit: this.onSubmit },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "inputGroup" },
                            React.createElement("label", null, "Address"),
                            React.createElement("input", { type: "text", maxLength: 50, value: this.state.location.street, name: "street", onChange: this.onChange, placeholder: "Address", required: true }))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "inputGroup" },
                            React.createElement("label", null, "City"),
                            React.createElement("input", { type: "text", maxLength: 50, value: this.state.location.city, name: "city", onChange: this.onChange, placeholder: "City", required: true })),
                        React.createElement("div", { className: "inputGroup", style: { 'width': '120px' } },
                            React.createElement("label", null, "State"),
                            React.createElement("input", { type: "text", maxLength: 2, value: this.state.location.state, name: "state", onChange: this.onChange, placeholder: "ST", required: true })),
                        React.createElement("div", { className: "inputGroup", style: { 'width': '250px' } },
                            React.createElement("label", null, "Zip"),
                            React.createElement("input", { maxLength: 5, value: this.state.location.zip, name: "zip", onChange: this.onChange, placeholder: "Zip", required: true, type: "text" }))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "inputGroup" },
                            React.createElement("label", null, "Apartment/Condo"),
                            React.createElement("select", { onChange: this.onChange, value: this.state.location.apartment, name: "apartment" },
                                React.createElement("option", { value: "Yes" }, "Yes"),
                                React.createElement("option", { value: "No" }, "No"))),
                        React.createElement("div", { className: "inputGroup" },
                            React.createElement("label", null, "# of Floors"),
                            React.createElement("select", { onChange: this.onChange, value: this.state.location.floors, name: "floors" },
                                React.createElement("option", { value: "1" }, "1"),
                                React.createElement("option", { value: "2" }, "2"))),
                        React.createElement("div", { className: "inputGroup" },
                            React.createElement("label", null, "Do you own the property"),
                            React.createElement("select", { onChange: this.onChange, value: this.state.location.own, name: "own" },
                                React.createElement("option", { value: "Yes" }, "Yes"),
                                React.createElement("option", { value: "No" }, "No")))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "inputGroup" },
                            React.createElement("label", null, "Have pets"),
                            React.createElement("select", { onChange: this.onChange, value: this.state.location.pets, name: "pets" },
                                React.createElement("option", { value: "Yes" }, "Yes"),
                                React.createElement("option", { value: "No" }, "No"))),
                        React.createElement("div", { className: "inputGroup" },
                            React.createElement("label", null, "Security gate/entrance"),
                            React.createElement("select", { onChange: this.onChange, value: this.state.location.securityGate, name: "securityGate" },
                                React.createElement("option", { value: "Yes" }, "Yes"),
                                React.createElement("option", { value: "No" }, "No"))),
                        React.createElement("div", { className: "inputGroup" },
                            React.createElement("label", null, "Color"),
                            React.createElement("input", { type: "text", maxLength: 50, value: this.state.location.color, name: "color", onChange: this.onChange, placeholder: "color", required: true }))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "inputGroup" },
                            React.createElement("label", null, "Special Instructions?"),
                            React.createElement("textarea", { onChange: this.onChange, value: this.state.location.directions, name: "directions", placeholder: "" }))),
                    React.createElement("div", { className: "row-right" },
                        React.createElement(Link, { to: "/activation" },
                            React.createElement("span", { className: "btn" }, "Back")),
                        React.createElement("button", { type: "submit", value: "Submit" }, "Next"))))));
    };
    return Location;
}(React.Component));
function mapStateToProps(state) {
    return {
        serviceEventId: state.serviceEvent.serviceEventId,
        locationState: state.serviceEvent.location
    };
}
export default withRouter(connect(mapStateToProps)(Location));
